import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import SectionHeading from "../ui/SectionHeading";
import TestimonialCard from "../ui/TestimonialCard";

const testimonials = [
  {
    name: "Ahmed Rahman",
    position: "CEO, TechSolve BD",
    content:
      "Professional Service Associates has been instrumental in helping us navigate complex tax regulations. Their expertise has saved us both time and money. Highly recommended!",
    rating: 5,
    image:
      "https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  {
    name: "Nadia Islam",
    position: "Director, Sunrise Imports",
    content:
      "Working with PSA transformed our approach to VAT and taxation. Their team is responsive, knowledgeable, and genuinely cares about our business success.",
    rating: 5,
    image:
      "https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  {
    name: "Rafiq Hasan",
    position: "Founder, GreenTech Solutions",
    content:
      "The accounting solutions provided by PSA have streamlined our financial processes. Their attention to detail and professional advice has been invaluable.",
    rating: 4,
    image:
      "https://images.pexels.com/photos/1516680/pexels-photo-1516680.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  {
    name: "Samira Jahan",
    position: "Managing Director, Elegance Textiles",
    content:
      "PSA's guidance through BIDA requirements was exceptional. They made a complex process simple and efficient. Our company saved valuable time and resources.",
    rating: 5,
    image:
      "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  {
    name: "Kamal Uddin",
    position: "CFO, Metro Developers",
    content:
      "We've been working with PSA for over 3 years now, and their tax planning strategies have consistently delivered results. A trusted partner for our business.",
    rating: 5,
    image:
      "https://images.pexels.com/photos/2182970/pexels-photo-2182970.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  {
    name: "Fahmida Khan",
    position: "Owner, Artisan Crafts",
    content:
      "As a small business owner, I needed guidance on company formation and licensing. PSA provided clear, actionable advice that helped establish my business properly.",
    rating: 4,
    image:
      "https://images.pexels.com/photos/1181686/pexels-photo-1181686.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
];

const Testimonials = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) {
        setSlidesToShow(1);
      } else if (window.innerWidth < 1024) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(3);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const totalSlides = testimonials.length;
  const maxSlideIndex = totalSlides - slidesToShow;

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev >= maxSlideIndex ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev <= 0 ? maxSlideIndex : prev - 1));
  };

  return (
    <section className="py-20 bg-psa-green-50">
      <div className="container mx-auto px-4">
        <SectionHeading
          title="What Our Clients Say"
          subtitle="Don't just take our word for it. Here's what clients have to say about our services and expertise."
          center
        />

        <div className="relative mt-12">
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -ml-4 lg:-ml-8 z-10 bg-white p-2 rounded-full shadow-lg hover:bg-gray-100 focus:outline-none transition-colors duration-300"
            aria-label="Previous testimonial"
          >
            <ChevronLeft size={24} className="text-psa-green-600" />
          </button>

          <div className="overflow-hidden">
            <div
              className="flex transition-transform duration-500 ease-in-out"
              style={{
                transform: `translateX(-${
                  currentSlide * (100 / slidesToShow)
                }%)`,
              }}
            >
              {testimonials.map((testimonial, index) => (
                <div
                  key={index}
                  className="min-w-full sm:min-w-[50%] lg:min-w-[33.333%] px-4"
                >
                  <TestimonialCard
                    name={testimonial.name}
                    position={testimonial.position}
                    content={testimonial.content}
                    rating={testimonial.rating}
                    image={testimonial.image}
                  />
                </div>
              ))}
            </div>
          </div>

          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 -mr-4 lg:-mr-8 z-10 bg-white p-2 rounded-full shadow-lg hover:bg-gray-100 focus:outline-none transition-colors duration-300"
            aria-label="Next testimonial"
          >
            <ChevronRight size={24} className="text-psa-green-600" />
          </button>
        </div>

        <div className="flex justify-center mt-8 space-x-2">
          {[...Array(maxSlideIndex + 1)].map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-colors duration-300 ${
                currentSlide === index ? "bg-psa-green-600" : "bg-gray-300"
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
